import {SxProps, Theme} from '@mui/material';

const container: SxProps<Theme> = {
  marginBottom: theme => theme.spacing(2.4),
};

export const useStyles = () => {
  return {container};
};
